import Avatar1 from '@/assets/images/avatars/1.png'
import Avatar2 from '@/assets/images/avatars/2.png'
import Avatar3 from '@/assets/images/avatars/3.png'
import Avatar4 from '@/assets/images/avatars/4.png'
import Avatar5 from '@/assets/images/avatars/5.png'
import Avatar6 from '@/assets/images/avatars/6.png'
import Avatar7 from '@/assets/images/avatars/7.png'
import Avatar8 from '@/assets/images/avatars/8.png'
import Avatar9 from '@/assets/images/avatars/9.png'
import Avatar10 from '@/assets/images/avatars/10.png'
import Avatar11 from '@/assets/images/avatars/11.png'
import Avatar12 from '@/assets/images/avatars/12.png'
import Avatar13 from '@/assets/images/avatars/13.png'
import Avatar14 from '@/assets/images/avatars/14.png'
import Avatar15 from '@/assets/images/avatars/15.png'
import Avatar16 from '@/assets/images/avatars/16.png'
import Avatar17 from '@/assets/images/avatars/17.png'
import Avatar18 from '@/assets/images/avatars/18.png'
import Avatar19 from '@/assets/images/avatars/19.png'
import Avatar20 from '@/assets/images/avatars/20.png'
import Avatar21 from '@/assets/images/avatars/21.png'
import Avatar22 from '@/assets/images/avatars/22.png'
import Avatar23 from '@/assets/images/avatars/23.png'
import Avatar24 from '@/assets/images/avatars/24.png'
import Avatar25 from '@/assets/images/avatars/25.png'
import Avatar26 from '@/assets/images/avatars/26.png'
import Avatar27 from '@/assets/images/avatars/27.png'
import Avatar28 from '@/assets/images/avatars/28.png'
import Avatar29 from '@/assets/images/avatars/29.png'
import Avatar30 from '@/assets/images/avatars/30.png'
import { StaticImageData } from 'next/image'

/**
 * Generate a consistent avatar index based on wallet address
 * @param address - Wallet address (Hyperliquid account)
 * @returns Avatar index between 1 and 30
 */
export function getAvatarIndex(address: string): number {
  if (!address)
    return 1

  // Convert address to lowercase and remove '0x' prefix if present
  const cleanAddress = address.toLowerCase().replace(/^0x/, '')

  // Simple hash function to generate a number from the address
  let hash = 0
  for (let i = 0; i < cleanAddress.length; i++) {
    const char = cleanAddress.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash &= hash // Convert to 32-bit integer
  }

  // Convert to positive number and map to 1-30 range
  const index = (Math.abs(hash) % 30) + 1

  return index
}

/**
 * Get avatar image path based on index
 * @param index - Avatar index (1-30)
 * @returns Avatar image path string
 */
export function getAvatarImage(index: number): StaticImageData {
  // Ensure index is within valid range
  const validIndex = Math.max(1, Math.min(30, index))

  // Map each index to its corresponding imported image
  const avatarMap: Record<number, StaticImageData> = {
    1: Avatar1,
    2: Avatar2,
    3: Avatar3,
    4: Avatar4,
    5: Avatar5,
    6: Avatar6,
    7: Avatar7,
    8: Avatar8,
    9: Avatar9,
    10: Avatar10,
    11: Avatar11,
    12: Avatar12,
    13: Avatar13,
    14: Avatar14,
    15: Avatar15,
    16: Avatar16,
    17: Avatar17,
    18: Avatar18,
    19: Avatar19,
    20: Avatar20,
    21: Avatar21,
    22: Avatar22,
    23: Avatar23,
    24: Avatar24,
    25: Avatar25,
    26: Avatar26,
    27: Avatar27,
    28: Avatar28,
    29: Avatar29,
    30: Avatar30,
  }
  
  return avatarMap[validIndex] || Avatar1
}
